// src/components/Page.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Heading, Box, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
// Importa il tuo componente per il rendering del rich text
import RenderCMSContent from '../components/RenderCMSContent';

const Page = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { pageId } = useParams();

  useEffect(() => {
    const fetchPage = async () => {
      try {
        // Effettua la richiesta alla route creata in Express
        const response = await axios.get(`/api/static-pages/${pageId}`);
        setPageData(response.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            'Errore durante il caricamento della pagina'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [pageId]);

  if (loading) {
    return (
      <Container maxW="lg" py={4}>
        <Text>Caricamento in corso...</Text>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxW="lg" py={4}>
        <Text color="red.500">{error}</Text>
      </Container>
    );
  }

  return (
    <Container maxW="full" py={4} px={10}>
      <Heading as="h1" mb={4}>
        {pageData.Titolo}
      </Heading>
      <Box>
        {/* 
          Passiamo il contenuto del rich text (assunto essere salvato in pageData.attributes.Content)
          al componente già realizzato che gestisce il rendering.
        */}
        <RenderCMSContent content={pageData.Content} />
      </Box>
    </Container>
  );
};

export default Page;
